import React, { useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, Empty, Typography, Avatar, Input, Button, message, Popconfirm } from 'antd'
// Ant Design Icons
import { CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons'
// Axios
import axios from 'axios'
// Config
import config from '../../config'
import { getConfig } from '../../config'

const { Title } = Typography

export const ContentDetails = ({ t, select, setSelect, isCreated, setIsCreated }) => {
    const navigate = useNavigate()

    function NoData() {
        return (
            <Flex justify="center" style={{ width: "100%" }}>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("select_user")} />
            </Flex>
        )
    }

    function Report() {
        const [messageApi, contextHolder] = message.useMessage()
        const [name, setName] = useState(select.full_name)
        const [email, setEmail] = useState(select.email)
        const [password, setPassword] = useState("")
        const [isEdit, setIsEdit] = useState(false)
        const [loading, setLoading] = useState(false)

        const onEdit = async() => {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/

            if(!emailRegex.test(email)) {
                messageApi.error(t("email_error"))
            }
            else if(password!=="" && !passRegex.test(password)) {
                messageApi.error(t("pass_complexity"))
            }
            else if(password!=="" && password.length<8) {
                messageApi.error(t("pass_length"))
            }
            else {
                setLoading(true)

                const userdata = {}
                if(select.full_name!==name) userdata.full_name = name
                if(select.email!==email) userdata.email = email
                if(password!=="") userdata.password = password

                try {
                    const res = await axios.put(`${config.urlApi}/private/users/${select._id}`, userdata, {
                        withCredentials: true
                    })
                    if(res.status===200) {
                        localStorage.setItem("updateUser", "true")
                        setIsEdit(false)
                        setLoading(false)
                        setIsCreated(!isCreated)
                    }
                }
                catch(err) {
                    if(err.status===409) {
                        messageApi.error(t("error_409_users"))
                    }
                    else if(err.status===404) {
                        messageApi.error(t("error_404_not_registered"))
                    }
                    else if (err.status === 401) {
                        navigate("/")
                    }
                    else {
                        messageApi.error(t("error_user_update"))
                    }
                    setLoading(false)
                }
            }
        }

        const onDelete = async() => {
            try {
                const res = await axios.delete(`${config.urlApi}/private/users/${select._id}`, {
                    withCredentials: true
                })
                if(res.status===200) {
                    localStorage.setItem("deleteUser", "true")
                    setSelect({})
                    setIsCreated(!isCreated)
                }
            }
            catch(err) {
                if (err.status === 401) {
                    navigate("/")
                }
                else if(err.status===404) {
                    messageApi.error(t("error_404_not_registered"))
                }
                else {
                    messageApi.error(t("error_user_delete"))
                }
            }
        }

        const firstLetter = (name) => name.charAt(0).toUpperCase()

        function hexToRgba(hex, opacity = 0.2) {
            hex = hex.replace(/^#/, '');
        
            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);
        
            return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }

        return (
            <Flex vertical align="center" style={{ position: "relative", width: "100%", height: "100%", padding: "20px" }}>
                <Avatar size={60} style={{ fontSize: "28px", marginRight: "10px", backgroundColor: hexToRgba(getConfig("colorSecundario")), color: getConfig("colorSecundario") }}>{firstLetter(select.full_name)}</Avatar>
                
                {isEdit
                    ? <Input onChange={(e) => setName(e.target.value)} value={name} style={{ width: "100%", margin: "10px 0" }} suffix={<CloseOutlined onClick={() => setIsEdit(false)} style={{ cursor: "pointer" }} />} />
                    : <Title level={3}>{select.full_name} <EditOutlined onClick={() => setIsEdit(true)} style={{ cursor: "pointer" }} /></Title>
                }

                <div style={{ width: "100%", height: "1px", backgroundColor: getConfig("colorPrimario") }}></div>

                <Flex justify="space-between" style={{ width: "100%", marginTop: "10px" }}>
                    <Flex vertical style={{ width: "48%" }}>
                        <Title level={5}>{t("email")}</Title>
                        <Input onChange={(e) => setEmail(e.target.value)} value={email} />
                    </Flex>
                    <Flex vertical style={{ width: "48%" }}>
                        <Title level={5}>{t("password")}</Title>
                        <Input.Password onChange={(e) => setPassword(e.target.value)} value={password} />
                    </Flex>
                </Flex>

                <Flex justify="space-evenly" style={{ width: "100%", marginTop: "20px" }}>
                    <Button onClick={onEdit} loading={loading} ghost icon={<EditOutlined />} style={{ backgroundColor: getConfig("colorPrimario"), color: "#fff" }}>{t("update")}</Button>

                    <Popconfirm
                        title={t("delete_user")}
                        description={t("sure_delete")}
                        onConfirm={onDelete}
                        okText={t("txt_yes")}
                        cancelText="No"
                        placement="bottom"
                        zIndex={999999}
                    >
                        <Button danger icon={<DeleteOutlined />}>{t("delete")}</Button>
                    </Popconfirm>
                </Flex>

                <CloseOutlined onClick={() => setSelect({})} style={{ position: "absolute", top: "15px", right: "15px", color: getConfig("colorSecundario"), fontSize: "24px", cursor: "pointer" }} />
                
                {contextHolder}
            </Flex>
        )
    }

    return (
        <Flex style={{ position: "relative", width: "70%", height: "calc(100vh - 60px)" }}>
            {select.email
                ? <Report />
                : <NoData />
            }
        </Flex>
    )
}
